<template>
    <a-menu
        mode="inline" :inlineIndent="16"
        :selectedKeys="[ $route.name || '' ]"
        :style="{ height: '100%', borderRight: 0 }"
        @select="switchPanel"
    >
        <a-menu-item key="home">
            <a-icon type="home" />
            <span>主页</span>
        </a-menu-item>
        <a-menu-item v-for="page of pages" :key="page.name">
            <a-icon :type="page.meta.icon" />
            <span>{{ page.meta.title }}</span>
        </a-menu-item>
    </a-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('$privilege', [ "pages" ])
    },
    methods: {
        switchPanel({ key }) {
            this.$router.push({ name: key });
        },
    }
}
</script>

<style>

</style>